import styled from 'styled-components';

import OfferStatusTooltip from './OfferStatusTooltip';

export default styled(OfferStatusTooltip)`
  padding: 1em;
`;
